import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as userAction from "../../../redux/actions/userAction";
import * as adminAction from "../../../redux/actions/adminCommonAction";

import ContractorList from "../component/contractor/contractorList";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import {
  ACCESS_DENIED,
  ADD_ADMIN_GROUP,
  ADMIN_CONTRACTOR,
  ADMIN_CONTRACTOR_DETAILS,
  ADMIN_CONTRACTOR_LIST,
} from "../../../constant/routeContant";
import * as contractorAction from "../../../redux/actions/contractorAction";
import { API_STATUS, ORG_ID } from "../../../constant/constant";
import { checkPrivileges } from "../../../utils/rolesHelper";
import { InactiveClient } from "../../../utils/helper";
import Loader from "../../../library/common/Loader";
import { getPreviousRoute } from "../../../utils/routeTracker";

const ContractorContainer = () => {
  const dispatch = useDispatch();
  const addUsers = () => {};
  const navigate = useNavigate();
  const [sendEmail, setSendEmail] = useState(false);
  const [shouldRestoreState, setShouldRestoreState] = useState(false);
  const deleteTriggeredRef = useRef(false);
  const NavigateSingleUserMethode = () => {
    if (InactiveClient()) return;
    navigate(ADMIN_CONTRACTOR);
  };
  const NavigateUserGroupMethode = () => {
    navigate(ADD_ADMIN_GROUP);
  };
  const contractorGrades = useSelector(
    (state) => state.getDropdownDataKeyValue?.data?.contractorGrades,
  );
  const contractorTypes = useSelector(
    (state) => state.getDropdownDataKeyValue?.data?.contractorTypes,
  );
  const [clickVerifyBtn, setClickVerifyBtn] = useState(false);
  const [accessUserId, setAccessUserId] = useState([]);
  const sendBulkEmailVerificationData = useSelector(
    (state) => state.sendBulkEmailVerification,
  );
  const sendBulkEmailVerificationDataIsLoading = useSelector(
    (state) => state.sendBulkEmailVerification?.isLoading,
  );

  const getuserLists = () => {
    dispatch(userAction.getUserList());
  };

  const deleteContractors = useSelector((state) => state.deleteContractor);
  const deleteList = (id) => {
    if (InactiveClient()) return;
    deleteTriggeredRef.current = true;
    dispatch(contractorAction.deleteContractor(id));
  };

  useEffect(() => {
    getuserLists();
    dispatch(userAction.ClearSendEmailVerification());
    dispatch(userAction.ClearSendBulkEmailVerification());
    setAccessUserId([]);
  }, []);

  const defaultData = {
    page: 1,
    pageSize: 10,
    search: "",
    gradeId: "",
    divisionId: 0,
    isSendMail: false,
  };

  const ContractorListData = useSelector((state) => state.getContractorList);

  const getContractorListData = (data) => {
    if (data?.isSendMail) {
      setSendEmail(true);
    } else {
      setSendEmail(false);
    }
    dispatch(contractorAction.getContractorList(data));
    dispatch(contractorAction.getContractorListFilterObj(data));
  };
  const getDropdownDataKeyValueData = {
    orgId: ORG_ID(),
    flags: "3,6,2",
  };
  useEffect(() => {
    if (
      deleteContractors.status === API_STATUS.SUCCESS &&
      deleteTriggeredRef.current
    ) {
      deleteTriggeredRef.current = false;
      const currentFilter = ContractorListData?.filterObj || defaultData;
      getContractorListData(currentFilter);
    }
  }, [deleteContractors]);

  useEffect(() => {
    const previousRoute = getPreviousRoute();
    const preserveRoutes = [ADMIN_CONTRACTOR_DETAILS, ADMIN_CONTRACTOR];
    const isFromPreserveRoute =
      previousRoute &&
      preserveRoutes.some((r) => previousRoute.startsWith(r)) &&
      sessionStorage.getItem("contractorListPreserveState") === "true";
    sessionStorage.removeItem("contractorListPreserveState");

    dispatch(adminAction.getDropdownDataKeyValue(getDropdownDataKeyValueData));
    if (isFromPreserveRoute && ContractorListData?.filterObj) {
      setShouldRestoreState(true);
      getContractorListData(ContractorListData.filterObj);
    } else {
      setShouldRestoreState(false);
      getContractorListData(defaultData);
    }
  }, []);

  useEffect(() => {
    if (ContractorListData?.status === API_STATUS.SUCCESS && sendEmail) {
      toast("Contractor has been sent to registered email ID");
    }
  }, [ContractorListData]);

  useEffect(() => {
    if (sendBulkEmailVerificationData?.status === "SUCCESS" && clickVerifyBtn) {
      setAccessUserId([]);
      setClickVerifyBtn(false);
      toast("Verification email sent successfully.");
      setTimeout(() => {
        window.location.reload();
      }, 3800);
    }
  }, [sendBulkEmailVerificationData]);

  const sendBulkEmailVarifation = (payload) => {
    if (InactiveClient()) return;
    dispatch(userAction.postSendBulkEmailVerification(payload));
  };

  return (
    <>
      {checkPrivileges([12, 43, 44, 45]) ? (
        <>
          {sendBulkEmailVerificationDataIsLoading && <Loader />}
          <ToastContainer />
          <ContractorList
            addUsers={addUsers}
            loading={
              ContractorListData?.isLoading || deleteContractors.isLoading
            }
            contractorListData={ContractorListData?.data}
            getContractorListData={getContractorListData}
            contractorGrades={contractorGrades ?? []}
            NavigateSingleUser={NavigateSingleUserMethode}
            NavigateUserGroup={NavigateUserGroupMethode}
            deleteList={deleteList}
            contractorTypes={contractorTypes ?? []}
            isShowDowdownloadButton={true}
            sendBulkEmailVarifation={sendBulkEmailVarifation}
            setClickVerifyBtn={setClickVerifyBtn}
            setAccessUserId={setAccessUserId}
            accessUserId={accessUserId}
            ContractorListDatas={ContractorListData}
            shouldRestoreState={shouldRestoreState}
          />
        </>
      ) : (
        navigate(ACCESS_DENIED)
      )}
    </>
  );
};

export default ContractorContainer;
